import * as request from '@/utils/request'

export default {
  /**
   * @description 创建/修改 通用付款申请 normal_payment_template
   * @returns promise
   */
  normarlPayment() {
    return request.post('/kol_normarl_payment/save_template', {})
  },
  /**
   * @description 创建/修改通用报销申请
   * @returns promise
   */
  normarlReimbursement(data) {
    return request.post('/kol_normarl_reimbursement/save_template', data)
  },
  /**
   * @description 创建/修改备用金申请
   * @returns promise
   */
  pettyCash() {
    return request.post('/kol_petty_cash/save_template')
  },
  /**
   * @description 创建/修改推广投放付款申请
   * @returns promise
   */
  kolApprove() {
    return request.post('/kol-approve/save_template')
  },
  /**
   * @description 创建/修改红人费用报销申请
   * @returns promise
   */
  kolExpense() {
    return request.post('/kol-expense/save_template')
  },
  /**
   * @description 创建/修改差旅报销申请
   * @returns promise
   */
  saveTravel() {
    return request.post('/kol_travel/save_template')
  },

  /**
   * 创建OA审批模板
   * @param template
   * @returns {Promise}
   */
  async createOATemplate(template) {
    let templateRouterName = ''
    switch (template) {
      case 'divide_template':
        // 红人分成付款申请
        templateRouterName = 'kol-divide'
        break
      case 'travel_template':
        //差旅报销申请
        templateRouterName = 'kol_travel'
        break
      case 'expense_template':
        // 红人费用报销申请
        templateRouterName = 'kol-expense'
        break
      case 'petty_cash_template':
        // 备用金申请
        templateRouterName = 'kol_petty_cash'
        break
      case 'normal_reimbursement_template':
        // 通用报销申请
        templateRouterName = 'kol_normarl_reimbursement'
        break
      case 'normal_payment_template':
        // 通用付款申请
        templateRouterName = 'kol_normarl_payment'
        break
      case 'payment_template':
        //推广投放付款申请
        templateRouterName = 'kol-approve'
        break;

    }

    return await request.post(`/${templateRouterName}/save_template`, {})
  },
  /**
   * @description Oa模板列表
   */
  oaTemplateList(data) {
    return request.post('/kol_template/list', data)
  },
  /**
   * @description Oa模板统计申请
   * @author YM
   * @date 2019-01-10
   * @returns promise
   */
  countTemplateList(data) {
    return request.post('/kol_template/tpl_apply_count', data)
  },
  /**
   * @description Oa模板設置
   * @author YM
   * @date 2019-01-10
   * @returns promise
   */
  oaTemplateGetInfo(data) {
    return request.post('/process_instance_settings/get_info', data)
  },
  /**
   * @description Oa模板設置
   * @author YM
   * @date 2019-01-10
   * @returns promise
   */
  oaTemplateSaveInfo(data) {
    return request.post('/process_instance_settings/store', data)
  },
  /**
   *
   * @param data
   * @returns {Promise}
   */
  oaTemplateProcessSetting(data) {
    return request.post('/process_instance_settings/get_process_setting', data)
  },
  /**
   *
   * @param data 删除
   * @returns {Promise}
   */
  oaTemplatedelSetting(id) {
    return request.post('/process_instance_settings/delete', { id: id })
  }
// /process_instance_settings/store
}
